export enum SystemTypeEnum {
  ADMINISTRATIVE = "ADMINISTRATIVE",
  GREYWATER = "GREYWATER",
  STORMWATER = "STORMWATER",
  UNKNOWN = "UNKNOWN",
  WASTEWATER = "WASTEWATER",
  WATER = "WATER",
  INDUSTRIAL = "INDUSTRIAL",
}
